
// 登录页面——主流程
const MainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `page/login/index${i + 1}`,
  name: `page/loginIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/login/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 登录页面——主流程，开始
    ...MainRoutes
  ]
}
